import { useDispatch, useSelector } from 'react-redux';
import * as Tab from '../../../util/TabValue';
import { CoreGoogleDevice } from '../../../models/CoreDeviceModels';
import { RequestState } from '../../../models/RequestState';
import { RootState } from '../../../store/store';
import { useParams, Link, Routes, Route, Navigate } from 'react-router-dom';
import { GetGoogleDevice } from '../../../store/DeviceAction';
import React,{ useEffect, Suspense, ReactNode } from 'react';
import StatusCode from '../../../util/StatusCode';
import Loading from '../../misc/Loading';
import NotFound from '../../administration/components/NotFound';
import { useTranslation } from 'react-i18next';
import DeviceViewInfo from './DeviceViewInfo';
import RenderTabs from '../../misc/Tabs';
import DeviceViewTrackings from './DeviceViewTrackings';
import DeviceViewObjectLogs from './DeviceViewObjectLogs';

const DeviceView = () => {
    const { t } = useTranslation(['device', 'common']);
    const dispatch = useDispatch();
    const device = useSelector<RootState, RequestState<CoreGoogleDevice>>(state => state.device.googleDevice)
    const { googleDeviceId } = useParams();

    useEffect(() => {
        if (googleDeviceId !== undefined) {
            GetGoogleDevice(googleDeviceId)(dispatch)
        }

    }, [dispatch, googleDeviceId]);

    const tabs = [
        Tab.Tabs.Information,
        Tab.Tabs.ObjectLogs,
        Tab.Tabs.Trackings,
    ];

    if (googleDeviceId === undefined)
        return; 

    const renderContent = (body: ReactNode) => (
        <div className="padding-40 container single">
            <h1><Link to="/device/googledevices">{t('object.googleDevice.device_one', { ns: 'common' })} </Link> {displayName} </h1>
        {body}
        </div>
    ); 

    let displayName: string | undefined = ''; 
    switch (device.code) {
        case StatusCode.COMPLETE:
            displayName = device.data.serialNumber;
            return (renderContent(<>
                <RenderTabs
                    tabs={tabs}
                    id={googleDeviceId}
                    url="device" />

                <Suspense fallback={<Loading />}>
                    <Routes>
                        <Route path={Tab.Tabs.Information.url} element={<DeviceViewInfo />} />
                        <Route path={Tab.Tabs.ObjectLogs.url} element={<DeviceViewObjectLogs />} />
                        <Route path={Tab.Tabs.Trackings.url} element={<DeviceViewTrackings />} />
                        <Route path="*" element={<Navigate replace={true} to={`/device/${googleDeviceId}/${Tab.Tabs.Information.url}`} />} />
                    </Routes>
                </Suspense>
            </>));

        case StatusCode.ERROR:
            if (device.error.response?.status === 404 || device.error.response?.status === 400) {
                return (
                    <NotFound
                        header={t('object.googleDevice.device_one', { ns: 'common', count: 1 })}
                        translateKey={{ i18nKey: "device.notFound", ns: "device" }}
                        link="/device/googledevices"
                    />
                );
            } else {
                return renderContent(<p> {device.error.response?.statusText}</p>);
            }
        default: return (renderContent(<Loading />));


    }
}

export default DeviceView; 